class ButtonController {
	$onInit() {
		this.btnClass = this.btnClass || 'btn btn-primary';
	}
}

export default ButtonController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/button/button.controller.js